import DirectionReveal from 'direction-reveal';

export default function() {

    // Init with default setup
    const directionRevealDemo = DirectionReveal();

    // Init with all options at default setting
    const directionRevealDefault = DirectionReveal({
        selector: '.js-direction-reveal',
        itemSelector: '.js-direction-reveal__item',
        animationName: 'swing',
        animationPostfixEnter: 'enter',
        animationPostfixLeave: 'leave',
        enableTouch: true,
        touchThreshold: 250
    });

}
